import { cn } from '../../lib/css/className/className';
import './verticalAlign.css';
import { headerStyles } from '../../components/Header/utils';
import { paragraphStyles } from '../../components/Paragraph/utils';
import { textStyles } from '../../components/Text/utils';

import {
    VerticalAlignOptions,
    HeaderVerticalAlignOptions,
    ParagraphVerticalAlignOptions,
    TextVerticalAlignOptions,
} from './types';

const cls = cn('verticalAlign');

/**
 * React Hook для применения стилей типографики
 * Задает свойства:
 * - padding-top и padding-bottom для текста и аддона
 * - line-height для текста и текстового аддона
 * - height аддона
 */
export const useVerticalAlign = (
    options: HeaderVerticalAlignOptions | ParagraphVerticalAlignOptions | TextVerticalAlignOptions,
): { textClasses: string; captionClasses: string | undefined; addonClasses: string | undefined } => {
    const { component, addonSize } = options;

    let textSize;

    switch (component) {
        case 'header':
            const { hasCaption, level } = options;
            textSize = hasCaption ? headerStyles[level].withCaption : headerStyles[level].withoutCaption;
            break;
        case 'paragraph':
            textSize = paragraphStyles[options.size];
            break;
        case 'text':
            textSize = textStyles[options.size];
            break;
    }

    return useInternalVerticalAlign({ textSize, addonSize });
};

/**
 * React Hook для применения стилей типографики
 * Задает свойства:
 * - padding-top и padding-bottom для текста и аддона
 * - line-height для текста и текстового аддона
 * - height аддона
 *
 * @internal - хук для создания компонентов библиотеки
 */
export const useInternalVerticalAlign = (
    options: VerticalAlignOptions,
): { textClasses: string; captionClasses: string | undefined; addonClasses: string | undefined } => {
    const { textSize, addonSize } = options;

    const textPreset = textSize.replace(' + ', '-');
    const hasCaption = textSize.includes('+');
    const addonPreset = addonSize && addonSize + '-text-' + textSize.slice(0, 5);

    const textClasses = cls({ text: textPreset, addon: addonSize });
    const addonClasses = addonSize && cls({ addon: addonPreset });
    const captionClasses = hasCaption ? cls({ caption: textPreset }) : undefined;

    return { textClasses, captionClasses, addonClasses };
};
